import React from 'react';
import { translations } from '../i18n/translations';
import Utils from './../utils/mci-utils';
import numeral from 'numeral';
const GoodList = ({ goods = [], currency, removeGoodsFn }) => {
  return (
    <div className="clearfix">
      <table className="table table-bordered goods-table">
        <thead>
          <tr>
            <th width="50%">{translations.goods}</th>
            <th className="text-right">Quantity</th>
            <th className="text-right">CFR ({currency.currency_code})</th>
            <th className="text-right">CFR ({translations.currency})</th>
            <th className="text-right">EDIT</th>
          </tr>
        </thead>
        <tbody>
          {goods.map(good => {
            return (
              <tr key={good.section}>
                <td>
                  <span className="text-success">{good.section_name}</span>
                  <br />
                </td>
                <td className="text-right">{good.quantity}</td>
                <td className="text-right">
                  {Utils.parseAmount(Utils.removeCommas(good.cfr))}
                </td>
                <td className="text-right">
                  {Utils.parseAmount(
                    Utils.removeCommas(good.cfr) * currency.rate
                  )}
                </td>
                <td>
                  <span
                    className="label label-danger label-btn"
                    onClick={() => {
                      removeGoodsFn(good);
                    }}
                  >
                    &times;
                  </span>
                </td>
              </tr>
            );
          })}
          <tr className="totals">
            <td className="text-right" colSpan="2">
              Total
            </td>
            <td className="text-right">
              {Utils.parseAmount(
                goods.reduce(
                  (sum, good) => (sum += Utils.removeCommas(good.cfr)),
                  0
                )
              )}
            </td>
            <td className="text-right">
              {Utils.parseAmount(
                goods.reduce(
                  (sum, good) =>
                    (sum += Utils.removeCommas(good.cfr) * currency.rate),
                  0
                )
              )}
            </td>
          </tr>
        </tbody>

        {goods.length === 0 ? (
          <div className="alert alert-danger">
            {translations.no_goods_added}
          </div>
        ) : null}
      </table>
    </div>
  );
};

GoodList.propTypes = {};

export default GoodList;



// WEBPACK FOOTER //
// ./src/components/GoodList.js